import type { ReactNode } from 'react'

import { cn } from 'utils/classMerge'

interface ModalContentProps {
  children: ReactNode
  orientation?: 'left' | 'center'
  className?: string
}

export default function ModalContent({
  children,
  orientation = 'center',
  className,
}: ModalContentProps) {
  return (
    <div
      className={cn(className, {
        'tw-text-left': orientation === 'left',
        'tw-text-center': orientation === 'center',
      })}
    >
      {children}
    </div>
  )
}
